import { createReducer, on } from '@ngrx/store';
import * as SectionIdActions from './section.action';

export const initialState = 'details';

export const sectionIdReducer = createReducer(
  initialState,
  on(SectionIdActions.updateId, (state, props) => props.id)
);
